// extracted by css-extract-rspack-plugin
export default {"headshot":"_b6275546","image":"_99699549"};